import { Button, Modal } from "react-bootstrap"

interface IActModal{
    setShow:React.Dispatch<React.SetStateAction<boolean>>
    show:boolean
    text:string
}

export const ActModal = (params:IActModal) => {
    return (
            <Modal show={params.show}  backdrop="static" keyboard={false}>
                <Modal.Header closeButton>
                    <Modal.Title>Получение акта сверки</Modal.Title>
                </Modal.Header>
                <Modal.Body>{params.text}</Modal.Body>
                <Modal.Footer>
                    <Button variant="success" size="sm" onClick={()=>params.setShow(false)}>ОК</Button>
                </Modal.Footer>
            </Modal>
    )
}